export default __webpack_public_path__ + "static/media/blue-star.4737934b.svg";